/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Error_EmailInputs */

const en_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid email address.`)
};

const de_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine gültige E-Mail-Adresse ein.`)
};

const fr_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez une adresse e-mail valide.`)
};

const es_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce un correo válido.`)
};

const it_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un’e-mail valida.`)
};

const nl_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een geldig e-mailadres in.`)
};

const pl_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj prawidłowy adres e-mail.`)
};

const fi_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anna kelvollinen sähköpostiosoite.`)
};

const da_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast en gyldig e-mailadresse.`)
};

const sv_consumer_declaration_error_email = /** @type {(inputs: Consumer_Declaration_Error_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange en giltig e-postadress.`)
};

/**
* | output |
* | --- |
* | "Enter a valid email address." |
*
* @param {Consumer_Declaration_Error_EmailInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_error_email = /** @type {((inputs?: Consumer_Declaration_Error_EmailInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Error_EmailInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_error_email(inputs)
	if (locale === "fr") return fr_consumer_declaration_error_email(inputs)
	if (locale === "es") return es_consumer_declaration_error_email(inputs)
	if (locale === "it") return it_consumer_declaration_error_email(inputs)
	if (locale === "nl") return nl_consumer_declaration_error_email(inputs)
	if (locale === "pl") return pl_consumer_declaration_error_email(inputs)
	if (locale === "fi") return fi_consumer_declaration_error_email(inputs)
	if (locale === "da") return da_consumer_declaration_error_email(inputs)
	if (locale === "sv") return sv_consumer_declaration_error_email(inputs)
	return en_consumer_declaration_error_email(inputs)
});